import { Controller, useForm } from "react-hook-form";
import { useAppState } from "../State"
import { PhoneInput, EmailInput } from "../components/contact";
import { CheckFormSubmit } from "../components/buy/CheckFormSubmit";
import { useState } from "react";
import { Modal } from "../components/common/Modal";

export const Contact = () => {
    const [state, setState] = useAppState();
    
    const {
        control,
        handleSubmit,
        watch
    } = useForm({
        defaultValues: {
            phone: state.phone,
            email: state.email,
            agreeTerms: false,
            agreePersonal: false
        }, mode: "onChange"
    });

    const saveData = (data) => {
        setState({ ...state, ...data, step: 2 });
    };

    const [openTerms, setOpenTerms] = useState(false);
    const [openPersonal, setOpenPersonal] = useState(false);

    const checkFormSubmitHandler = () => {
        const w = watch();
        const contactInvalid = CheckFormSubmit('phone', w) || CheckFormSubmit('email', w);
        const agreementsValid = !!w.agreeTerms && !!w.agreePersonal;
        return contactInvalid || !agreementsValid;
    }

    return (
        <div className="contact_step">
            <form className="contact_step-form" onSubmit={handleSubmit(saveData)}>
                <p className="contact_step-title">Укажите номер телефона<br />для получения ссылки на билет</p>
                <Controller
                    control={control}
                    name="phone"
                    defaultValue={''}
                    render={
                        ({ field: { onChange, value } }) =>
                            <PhoneInput onChange={onChange} value={value} />
                    } />
                <Controller
                    control={control}
                    name="email"
                    defaultValue={''}
                    render={
                        ({ field: { onChange, value } }) =>
                            <EmailInput onChange={onChange} value={value} />
                    } />
                <div className="contact_agreements">
                    <label className="contact_agreement">
                        <Controller
                            control={control}
                            name="agreeTerms"
                            render={({ field: { onChange, value } }) => (
                                <input type="checkbox" checked={!!value} onChange={(e) => onChange(e.target.checked)} />
                            )}
                        />
                        <span>
                            Согласен с <button type="button" className="link-button" onClick={() => setOpenTerms(true)}>пользовательским соглашением</button>
                        </span>
                    </label>
                    <label className="contact_agreement">
                        <Controller
                            control={control}
                            name="agreePersonal"
                            render={({ field: { onChange, value } }) => (
                                <input type="checkbox" checked={!!value} onChange={(e) => onChange(e.target.checked)} />
                            )}
                        />
                        <span>
                            Согласен с <button type="button" className="link-button" onClick={() => setOpenPersonal(true)}>обработкой персональных данных</button>
                        </span>
                    </label>
                </div>
                <p className="contact_step-caption">Указывайте корректный телефон. На него придет СМС с билетом и чеком</p>
                <div className="contact_step-footer">
                    <button className="step-button" onClick={() => setState({ ...state, step: 0 })}>Назад</button>
                    <button disabled={checkFormSubmitHandler()} className="step-button" type="submit">Продолжить</button>
                </div>
            </form>
            <Modal title={'Пользовательское соглашение'} isOpen={openTerms} onClose={() => setOpenTerms(false)}>
                <p><b>Оператор:</b> ООО «ИМПЕРИЯ ИГР», ИНН 7452030395, ОГРН 1027403888126. Адрес: г. Челябинск, КРК «Мегаполис», Свердловский пр., 51А.</p>
                <p><b>Сайт/сервис:</b> booking.letotermy.ru.</p>
                <p><b>Предмет соглашения:</b> предоставление пользователю возможности оформить анкету и сгенерировать QR‑код, содержащий email и номер телефона, для последующей оплаты заказа</p>
                <p><b>Регистрация и идентификация:</b> пользователь указывает номер телефона, email. Подтверждение номера осуществляется кодом из SMS. Пользователь подтверждает корректность предоставляемых данных.</p>
                <p><b>Маркетинговые материалы:</b> направляются только при наличии отдельного согласия пользователя («Получать рекламные материалы»).</p>
                <p><b>Права и обязанности:</b> пользователь обязуется предоставлять достоверные данные и использовать сервис по назначению. Оператор вправе изменять функциональность сервиса и интерфейс без предварительного уведомления, при этом актуальная редакция Соглашения публикуется на сайте.</p>
                <p><b>Ограничение ответственности:</b> сервис предоставляется «как есть». Оператор не несет ответственность за сбои связи, работы сторонних провайдеров, а также за последствия, вызванные недостоверностью данных, введенных пользователем. Объем ответственности ограничен фактически причиненным реальным ущербом.</p>
                <p><b>Интеллектуальная собственность:</b> элементы дизайна, тексты, программный код являются объектами охраны. Пользователю предоставляется неисключительная лицензия на использование сервиса в пределах его функционала.</p>
                <p><b>Споры и применимое право:</b> к отношениям сторон применяется право РФ. Претензионный порядок — 30 календарных дней. Подсудность — по месту нахождения Оператора (г. Челябинск), если иное не установлено законом.</p>
                <p><b>Персональные данные:</b> обработка осуществляется в соответствии с Согласием/Политикой обработки персональных данных, опубликованной в сервисе.</p>
                <p><b>Вступление в силу:</b> Соглашение является офертой. Совершение действий по использованию сервиса (ввод данных, подтверждение номера) является акцептом. Актуальная редакция доступна на сайте.</p>
            </Modal>
            <Modal title={'Согласие на обработку персональных данных'} isOpen={openPersonal} onClose={() => setOpenPersonal(false)}>
            <p><b>Оператор ПД:</b> ООО «ИМПЕРИЯ ИГР», ИНН 7452030395, ОГРН 1027403888126. Адрес: г. Челябинск, КРК «Мегаполис», Свердловский пр., 51А.</p>
                <p><b>Сайт/сервис:</b> booking.letotermy.ru.</p>
                <p><b>Состав ПД:</b> номер телефона, email пользователя</p>
                <p><b>Цели обработки:</b> регистрация/идентификация пользователя, оформление заказ и онлайн оплаты, коммуникации по ходу использования сервиса.</p>
                <p><b>Правовые основания:</b> ст. 6 152‑ФЗ — согласие субъекта ПД; исполнение договора/оферты (оказание сервисной функциональности).</p>
                <p><b>Операции с ПД:</b> сбор, запись, систематизация, хранение, уточнение (обновление, изменение), использование, передача (банк эквайер), обезличивание, блокирование, удаление, уничтожение.</p>
                <p><b>Место и условия хранения:</b> данные размещены на инфраструктуре VK Cloud (MS1) в ЦОД DataLine NORD4, г. Москва, Коровинское ш., 41. Резервные копии хранятся бессрочно.</p>
                <p><b>Срок хранения:</b> до отзыва согласия или достижения целей обработки; фактически — бессрочно. По обращению субъекта ПД данные удаляются в срок до 30 календарных дней, если иное не требуется законом.</p>
                <p><b>Передача третьим лицам:</b> осуществляется только в объеме, необходимом для достижения целей (например, для внесения в ППС БАРС). Трансграничная передача не осуществляется, если иное прямо не предусмотрено функционалом сервиса.</p>
                <p><b>Cookies/локальное хранение:</b> сервис использует localStorage/аналогичные механизмы для хранения состояния шагов. Средства аналитики/рекламы не применяются.</p>
                <p><b>Маркетинговые материалы:</b> направление возможно исключительно при наличии отдельного согласия пользователя (отмеченная галочка «Получать рекламные материалы»). Отзыв согласия — в любой момент.</p>
                <p><b>Права субъекта ПД:</b> доступ к данным, запрос на уточнение/удаление, ограничение обработки, отзыв согласия, получение сведений о предоставлении доступа третьим лицам. Контакт для обращений: +7 (351) 240‑00‑24. Срок ответа — до 30 календарных дней.</p>
                <p><b>Безопасность ПД:</b> применяются необходимые правовые, организационные и технические меры защиты (разграничение доступа, защита каналов связи, резервное копирование и др.). Доступ ограничивается уполномоченными сотрудниками.</p>
                <p><b>Согласие:</b> подтверждается отметкой соответствующих галочек и использованием сервиса. Отозвать согласие можно посредством обращения по указанным контактам.</p>
            </Modal>
        </div>
    );
}